var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag.tag)?_c('div',{staticClass:"price-tag",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"tag-text",style:(_vm.priceStyle)},[_vm._v(_vm._s(_vm.tag.tag))]),_c('div',{staticClass:"arrow",style:(_vm.priceStyle)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }